export const GET_DATASET = 'app/DatasetEdit/GET_DATASET'
export const CLEAR_DATASET = 'app/DatasetEdit/CLEAR_DATASET'
export const GET_DATASET_DONE = 'app/DatasetEdit/GET_DATASET_DONE'
export const GET_DATASET_ERROR = 'app/DatasetEdit/GET_DATASET_ERROR'

export const UPDATE_DATASET = 'app/DatasetEdit/UPDATE_DATASET'

export const GET_RECORDS_PAGE = 'app/DatasetEdit/GET_RECORDS_PAGE'
export const CLEAR_RECORDS = 'app/DatasetEdit/CLEAR_RECORDS'
export const GET_RECORDS_PAGE_DONE = 'app/DatasetEdit/GET_RECORDS_PAGE_DONE'
export const GET_RECORDS_PAGE_ERROR = 'app/DatasetEdit/GET_RECORDS_PAGE_ERROR'

export const UPDATE_COLUMN = 'app/DatasetEdit/UPDATE_COLUMN'
export const UPDATE_COLUMN_ERROR = 'app/DatasetEdit/UPDATE_COLUMN_ERROR'

export const DEACTIVATE_RECORD = 'app/DatasetEdit/DEACTIVATE_RECORD'
export const DEACTIVATE_RECORD_ERROR = 'app/DatasetEdit/DEACTIVATE_RECORD_ERROR'

export const REPLACE_RECORD = 'app/DatasetEdit/REPLACE_RECORD'
export const REPLACE_RECORD_ERROR = 'app/DatasetEdit/REPLACE_RECORD_ERROR'

export const ADD_RECORD = 'app/DatasetEdit/ADD_RECORD'
export const ADD_RECORD_DONE = 'app/DatasetEdit/ADD_RECORD_DONE'
export const ADD_RECORD_ERROR = 'app/DatasetEdit/ADD_RECORD_ERROR'

export const ADD_COLUMN = 'app/DatasetEdit/ADD_COLUMN'
export const ADD_COLUMN_DONE = 'app/DatasetEdit/ADD_COLUMN_DONE'
export const ADD_COLUMN_ERROR = 'app/DatasetEdit/ADD_COLUMN_ERROR'

export const DATASET_DRAG_N_DROP_COLUMN =
  'app/DatasetEdit/DATASET_DRAG_N_DROP_COLUMN'
